export default "__VITE_ASSET__CDw9UQA3__"